// nuevos proveedores
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ProviderCard } from "../../../data/ecommerce/providers";
import ProductCard from "../../common/ProductCard";
import Swiper from "../../base/Swiper";
import { SwiperSlide } from "swiper/react";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const EcomBestOffers = ({ products }: { products: ProviderCard[] }) => {
  return (
    <>
      <div className="d-flex flex-between-center mb-3">
        <h3>Nuevos Proveedores</h3>
        <Link
          to="/home/searchpage"
          className="btn btn-link btn-lg p-0 d-none d-md-block"
        >
          Ver mas
          <FontAwesomeIcon icon={faChevronRight} className="fs-9 ms-1" />
        </Link>
      </div>
      <Swiper
        slidesPerView={1}
        spaceBetween={16}
        navigationPosition={{ top: "25%" }}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          450: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 6,
            spaceBetween: 16,
          },
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard product={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
};

export default EcomBestOffers;
